import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { Action } from '@models/swagger';
import { ActionsParams } from './service';

export enum PolicyActionsActions {
  Failure = '[Policy PolicyActions] Failure',
  Request = '[Policy PolicyActions] Request',
  Success = '[Policy PolicyActions] Success',
}

export const PolicyActionsFailure = createAction(PolicyActionsActions.Failure, props<{ error: HttpErrorResponse }>());

export const PolicyActionsRequest = createAction(PolicyActionsActions.Request, props<{ parameters: ActionsParams }>());

export const PolicyActionsSuccess = createAction(PolicyActionsActions.Success, props<{ data: Action[] }>());
